import $ from "jquery";
import { application } from "../application/application";
import { peopleDashboardFilters } from "./peopleDashboardFilters";
import { peopleSearch } from "./peopleSearch";
import { forms } from "../framework/forms";

let dataSet = [];
let personTable;
let currentPage = 1;
let hasNextPage = false;
const tableColumns = [
    "Id",
    "FirstName",
    "LastName",
    "AptifyId",
    "Email",
    "Role",
    "ExpirationText",
    "CommentCount"
];
let sort = null;
let onPopulateTable = function () { };

function init() {
    buildTable();
    peopleDashboardFilters.doSetup().done(function () {
        populateTable();
        setEvents();
    });
}

function setEvents() {
    $("#btnDownloadExcelCurrPage").click(function () {
        $(this).attr("href", exportPeopleToExcel(false));
    });
    $("#btnDownloadExcelAllx").click(function () {
        doTest();
    });

    function doTest() {
        if (isFilterEmpty()) {
            $(this).attr("href", "#");
            alert("Please enter search criteria.");
            return false;
        } else {
            //$(this).attr("href", exportPeopleToExcel(true)).attr("timeout", 10000);
            $.ajax({
                url: exportPeopleToExcel(true),
                type: "GET", // or "POST", "PUT", etc.
                timeout: 500000, // Set timeout to 5 seconds (5000 milliseconds)
                success: function (data) {
                    console.log("Download completed", data);
                    // Create a blob URL for the fetched blob
                    const blobUrl = window.URL.createObjectURL(data);

                    // Create a temporary link element
                    const link = document.createElement("a");
                    link.href = blobUrl;
                    link.download = "PeopleSearch" + getCurrentDateTimeString();
                    link.click();

                    // Revoke the object URL to release memory
                    window.URL.revokeObjectURL(blobUrl);
                },
                error: function (xhr, textStatus, errorThrown) {
                    // Handle error, including timeout error
                    if (textStatus === "timeout") {
                        console.log("The request timed out.");
                    } else {
                        console.error("An error occurred:", errorThrown);
                    }
                }
            });
        }
    }

    $("#btnDownloadExcelAll").click(function () {
        console.log("click btnDownloadExcelAll");
        if (isFilterEmpty()) {
            $(this).attr("href", "#");
            alert("Please enter search criteria.");
            return false;
        } else {
            document.body.style.cursor = "wait";
            const url = exportPeopleToExcel(true);

            console.log("Starting Fetch:", getCurrentDateTimeString());
            fetch(url, { timeout: 300000 })
                .then(response => {
                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }
                    console.log("Got response in  Fetch:", getCurrentDateTimeString());
                    return response.blob();
                })
                .then(blob => {
                    // Create a blob URL for the fetched blob
                    const blobUrl = window.URL.createObjectURL(blob);

                    // Create a temporary link element
                    const link = document.createElement("a");
                    link.href = blobUrl;
                    link.download = "PeopleSearch" + getCurrentDateTimeString();
                    link.click();

                    // Revoke the object URL to release memory
                    window.URL.revokeObjectURL(blobUrl);
                })
                .catch(error => {
                    // Handle errors
                    console.log("Error in  Fetch:", getCurrentDateTimeString());
                    console.error("Error:", error);
                })
                .finally(() => {
                    // Revert cursor style to default once fetch request completes
                    //$("body").css("cursor", "auto");
                    document.body.style.cursor = "auto";
                });
        }
    });

    $("#btnDownloadExcelAll1000").click(function () {
        console.log("click btnDownloadExcelAll");
        if (isFilterEmpty()) {
            $(this).attr("href", "#");
            alert("Please enter search criteria.");
            return false;
        } else {
            document.body.style.cursor = "wait";
            const url = exportPeopleToExcel(true);
            const controller = new AbortController();
            const signal = controller.signal;
            setTimeout(() => controller.abort(), 600000); // Abort after 10 minutes
            fetch(url, { signal })
                .then(response => {
                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }
                    return response.blob();
                })
                .then(blob => {
                    // Create a blob URL for the fetched blob
                    const blobUrl = window.URL.createObjectURL(blob);

                    // Create a temporary link element
                    const link = document.createElement("a");
                    link.href = blobUrl;
                    link.download = "PeopleSearch" + getCurrentDateTimeString();
                    link.click();

                    // Revoke the object URL to release memory
                    window.URL.revokeObjectURL(blobUrl);
                })
                .catch(error => {
                    // Handle errors
                    console.error("Error:", error);
                })
                .finally(() => {
                    // Revert cursor style to default once fetch request completes
                    //$("body").css("cursor", "auto");
                    document.body.style.cursor = "auto";
                });
        }
    });
    function getCurrentDateTimeString() {
        const now = new Date();

        const year = now.getFullYear();
        const month = ("0" + (now.getMonth() + 1)).slice(-2);
        const day = ("0" + now.getDate()).slice(-2);
        const hours = ("0" + now.getHours()).slice(-2);
        const minutes = ("0" + now.getMinutes()).slice(-2);
        const seconds = ("0" + now.getSeconds()).slice(-2);

        const dateTimeString = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
        return dateTimeString;
    }

    function isFilterEmpty() {
        const filters = peopleDashboardFilters.setFilters();
        return (
            filters.areaIds.length === 0 &&
            filters.countryId === undefined &&
            filters.keyword === "" &&
            filters.regionAreaId === "" &&
            filters.regionId === "" &&
            filters.roleIds.length === 0 &&
            filters.stateId === "" &&
            filters.stateText === "" &&
            filters.tagIds.length === 0
        );
    }

    function exportPeopleToExcel(getAll) {
        let source = "";
        if (getAll) {
            source = "/People/GetPeopleSearchExcel" + "/-1/?";
        } else {
            source = "/People/GetPeopleSearchExcel" + "/" + currentPage + "/?";
        }
        const sourceWithParams = (source += $.param(
            peopleDashboardFilters.getQueryStringFilters()
        ).replace(/%5B%5D/g, ""));
        return sourceWithParams;
    }

    $(document).on("mouseover", "#personTable tbody tr", function () {
        personTable.$(".dropdown").hide();
        $(this)
            .find(".dropdown")
            .show();
    });

    $(document).on("mouseleave", "#personTable", function () {
        personTable.$(".dropdown").hide();
    });

    //Set double click person select for grid.
    $(document).on("dblclick", "#personTable tbody tr", function () {
        const data = personTable.row(this).data();
        if (data === undefined) {
            return;
        }
        forms.showSpinner();
        window.location.href = application.baseUrl + "/person/index/" + data[0];
    });

    $("#personTable .sorting, #personTable .sorting_asc, #personTable .sorting_desc").click(
        function (e) {
            const asc = $(this).hasClass("sorting") || $(this).hasClass("sorting_desc");
            $(".sorting, .sorting_asc, .sorting_desc")
                .removeClass()
                .addClass("sorting");

            if (asc) {
                $(this)
                    .removeClass("sorting")
                    .removeClass("sorting_desc")
                    .addClass("sorting_asc");
            } else {
                $(this)
                    .removeClass("sorting")
                    .removeClass("sorting_asc")
                    .addClass("sorting_desc");
            }
            $(".sorting, .sorting_asc, .sorting_desc")
                .not($(this))
                .removeClass(".sorting_asc")
                .removeClass(".sorting_desc")
                .addClass("sorting");

            sort = {
                column: tableColumns[personTable.column(this).index()],
                columnIndex: personTable.column(this).index(),
                desc: $(this).hasClass("sorting_desc")
            };
            peopleDashboardFilters.setSort(sort.column, sort.columIndex, sort.desc);
            applyFilters();
        }
    );

    $("#previous").addClass("disabled");

    $("#next").click(goNextPage);

    $("#previous").click(goPreviousPage);

    $("#applyFilters").click(applyFilters);

    $("#clearFilters").click(clearFilters);

    $("#person-search").submit(function (e) {
        e.preventDefault();
        applyFilters();
    });
    if ($.isFunction(onPopulateTable)) {
        onPopulateTable(personTable);
    }
    //Set up role dropdown display and events.
}

function renderRolesFunction(d, t, r) {
    if (d === undefined || d.length <= 0) return "";
    let dropdown = "";
    d = removeDuplicateRoles(d);
    const filters = peopleDashboardFilters.getFilters();
    if (!filters.expired) d = filterExpiredRoles(d);
    if (d.length > 1) {
        dropdown =
            "<div class='btn-group btn-table'><button class='btn btn-secondary btn-sm-table dropdown-toggle' type='button' data-toggle='dropdown' aria-haspopup='true' aria-expanded='false'></button><div class='dropdown-menu'>";
        for (let i = 0; i < d.length; i++) {
            dropdown +=
                "<a><i class='fa fa-circle' style='color: " +
                d[i].displayColor +
                "'></i> " +
                d[i].name +
                "</a>";
        }
        dropdown += "</div></div>";
    }
    return (
        "<i class='fa fa-circle' style='color: " +
        d[0].displayColor +
        "'></i> " +
        d[0].name +
        dropdown
    );
}

function renderExpiredFunction(data, type, row) {
    let expired = false;
    let returnText = "";
    if (data === "Expired") {
        expired = true;
    }
    if (data === "") {
        returnText = "";
    } else {
        returnText = "<i class='fa fa-circle' style='color: " + (expired ? "Red" : "Green") + "'></i> " + data;
    }
    return (returnText);
}

function renderCommentsFunction(data, type, row) {
    return "<span class='badge badge-pill badge-secondary'>" + row[7] + "</span>";
}

function removeDuplicateRoles(roles) {
    const uniqueRoles = [];
    roles.forEach(function (item, pos) {
        if (
            !uniqueRoles.some(function (x) {
                return x.name === item.name;
            })
        ) {
            uniqueRoles.push(item);
        }
    });

    return uniqueRoles;
}

function setNextPrevButtonEnabled() {
    if (!hasNextPage) {
        $("#next").addClass("disabled");
    } else {
        $("#next").removeClass("disabled");
    }
    if (currentPage === 1) {
        $("#previous").addClass("disabled");
    } else {
        $("#previous").removeClass("disabled");
    }
}

function buildTable() {
    //Set up person grid.
    personTable = $("#personTable").DataTable({
        //"processing": true, // for show progress bar
        serverSide: false, // for process server side
        filter: false, // this is for disable filter (search box)
        //"orderMulti": false, // for disable multiple column at once
        data: dataSet,
        lengthChange: false,
        paginate: false,
        pageLength: 20,
        info: false,
        ordering: false,
        columnDefs: [
            {
                targets: 0,
                visible: false
            },
            {
                targets: 1,
                name: "firstName"
            },
            {
                targets: 2,
                name: "lastName"
            },
            {
                targets: 3,
                name: "aptifyId"
            },
            {
                targets: 4,
                name: "email"
            },
            {
                targets: 5,
                name: "role",
                render: renderRolesFunction
            },
            {
                targets: 6,
                name: "expirationText",
                render: renderExpiredFunction
            },
            {
                targets: 7,
                name: "comment",
                render: renderCommentsFunction
            }
        ]
    });
    peopleDashboardFilters.setPersonTable(personTable);
}
function goNextPage() {
    if (!hasNextPage) return;
    currentPage++;
    populateTable();
}

function goPreviousPage() {
    if (currentPage === 1) return;
    currentPage--;
    populateTable();
}

function applyFilters() {
    currentPage = 1;
    peopleDashboardFilters.setFilters();
    populateTable();
}

function clearFilters() {
    currentPage = 1;
    peopleDashboardFilters.clearFilters();
    populateTable();
}

function populateTable() {
    const filters = peopleDashboardFilters.getFilters();
    filters.currentPage = currentPage;
    return $.Deferred(function (def) {
        peopleSearch.getPeople(currentPage, filters).done(function (results) {
            personTable.clear();
            dataSet = [];
            for (let i = 0; i < results.people.length; i++) {
                if (!filters.expired) {
                    results.people[i].roles = filterExpiredRoles(results.people[i].roles);
                }
                if (results.people[i].isNew) {
                    results.people[i].isExpired = false;
                }
                const row = [
                    results.people[i].id,
                    results.people[i].firstName,
                    results.people[i].lastName,
                    results.people[i].aptifyId,
                    results.people[i].email,
                    results.people[i].roles,
                    results.people[i].expirationText,
                    results.people[i].commentCount,
                    results.people[i].isNew
                ];
                dataSet.push(row);
            }
            personTable.rows
                .add(dataSet)
                .columns.adjust()
                .draw();
            personTable.$(".dropdown").hide();
            hasNextPage = results.people.length > 20;
            setNextPrevButtonEnabled();

            if ($.isFunction(onPopulateTable)) {
                onPopulateTable(personTable);
            }
            def.resolve();
        });
    }).promise();
}

function filterExpiredRoles(roles) {
    if (!roles && !roles.length) return roles;
    if (roles.length === 1) return roles;
    return roles.filter(function (role) {
        if (role.IsNew) return false;
        if (!role.endDateUtc) return true;
        const now = new Date();
        return (
            new Date(role.endDateUtc) >
            new Date(
                now.getUTCFullYear(),
                now.getUTCMonth(),
                now.getUTCDate(),
                now.getUTCHours(),
                now.getUTCMinutes(),
                now.getUTCSeconds()
            )
        );
    });
}

function getPersonTable() {
    return personTable;
}
function setOnPopulateTable(functionPointer) {
    if (!$.isFunction(functionPointer)) return;
    onPopulateTable = functionPointer;
}

export const peopleDashboard = {
    init: init,
    renderRolesFunction: renderRolesFunction,
    renderExpiredFunction: renderExpiredFunction,
    renderCommentsFunction: renderCommentsFunction,
    getPersonTable: getPersonTable,
    setOnPopulateTable: setOnPopulateTable
};